import React, {useEffect} from 'react';
import NotFound from '../pages/errors/404';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import GuestRoute from "./guest-route";
import BaseError from "../pages/errors/base-error";
import {AppRoutes} from "../utils/constants";
import Signup from "../pages/auth/signup";
import Login from "../pages/auth/login";
import ForgotPassword from "../pages/auth/forgot-password";
import AuthRoute from "./auth-route";
import Discover from "../pages/discover/discover";
import {useAuth} from "../context/auth";
import InitialLoading from "../components/initial-loading";
import Inbox from "../pages/inbox/inbox";
import Schedule from "../pages/schedule/schedule";
import Following from "../pages/following/following";
import Profile from "../pages/auth/profile";
import ResendEmailConfirmation from "../pages/auth/resend-email-confirmation";
import CompleteProfile from "../pages/auth/complete-profile";
import SearchEvents from "../pages/search/search-events";
import TrainerDetail from "../pages/trainers/trainer-detail";
import EventDetail from "../pages/events/event-detail";
import Categories from "../pages/categories/categories";
import SearchTrainers from "../pages/search/search-trainers";
import ReactGA from "react-ga4";

export default function App () {

  const { initializing } = useAuth();

  useEffect(() => {
    //First applies the GA tracking id
    ReactGA.initialize(process.env.REACT_APP_GA_IDENTIFIER);
  }, []);

  const router = createBrowserRouter([
    {
      path: AppRoutes.landing.path,
      errorElement: <BaseError />,
      children: [
        {
          path: '/',
          element: <AuthRoute component={Discover} />
        },
        {
          path: AppRoutes.home.path,
          element: <AuthRoute component={Discover} />
        },
        {
          path: AppRoutes.trainers.path,
          children: [
            {
              path: ':id',
              element: <AuthRoute component={TrainerDetail} />
            },
          ]
        },
        {
          path: AppRoutes.events.path,
          children: [
            {
              path: ':id',
              element: <AuthRoute component={EventDetail} />
            },
          ]
        },
        {
          path: AppRoutes.following.path,
          element: <AuthRoute component={Following} />
        },
        {
          path: AppRoutes.eventCategories.path,
          element: <AuthRoute component={Categories} />
        },
        {
          path: AppRoutes.schedule.path,
          element: <AuthRoute component={Schedule} />
        },
        {
          path: AppRoutes.inbox.path,
          element: <AuthRoute component={Inbox} />
        },
        {
          path: AppRoutes.searchEvents.path,
          element: <AuthRoute component={SearchEvents} />
        },
        {
          path: AppRoutes.searchTrainers.path,
          element: <AuthRoute component={SearchTrainers} />
        },
        {
          path: AppRoutes.completeProfile.path,
          element: <AuthRoute component={CompleteProfile} />
        },
        {
            path: AppRoutes.profile.path,
            children: [
                {
                    path: '',
                    element: <AuthRoute component={Profile} />
                },
                {
                    path: ':tab',
                    element: <AuthRoute component={Profile} />
                },
            ]
        },
        {
          path: AppRoutes.login.path,
          element: <GuestRoute component={Login} />
        },
        {
          path: AppRoutes.signup.path,
          element: <GuestRoute component={Signup} />
        },
        {
          path: AppRoutes.passwordRecovery.path,
          element: <GuestRoute component={ForgotPassword} />
        },
        {
          path: AppRoutes.resendConfirmation.path,
          element: <GuestRoute component={ResendEmailConfirmation} />
        },
      ]
    },
    {
      path: '*',
      element: <NotFound />,
      errorElement: <BaseError />
    },
  ]);

  return (
      initializing ? <InitialLoading /> : <RouterProvider router={router} />
  );
}
